<nb-card>
  <nb-card-header>
    <h6 class="text-heading">
      {{ exercise.title }}
    </h6>

    <span *ngIf="view == 'quiz'">
      [ trả lời đúng {{ exerciseUser.noCorrect }} /
      {{ exerciseUser.noQuiz }} câu ]
    </span>
  </nb-card-header>

  <nb-card-body *ngIf="view != 'quiz'">
    <div class="contain-detail" *ngIf="view == 'info'">
      <div class="summary">
        <ngx-view-exercise-detail [exercise]="exercise">
        </ngx-view-exercise-detail>

        <button
          nbButton
          hero
          shape="round"
          size="small"
          status="info"
          [disabled]="
            loading ||
            !exercise.exQuizzes ||
            exercise.exQuizzes.length == 0 ||
            exercise.status != 1
          "
          [class.btn-pulse]="loading"
          class="action-button"
          (click)="doExercise()"
        >
          <nb-icon class="action-icon" icon="play-circle-outline"></nb-icon>
          Bắt đầu
        </button>
      </div>
    </div>

    <div class="contain-detail" *ngIf="view == 'resume'">
      <div class="summary">
        <ngx-view-exercise-detail [exercise]="exercise">
        </ngx-view-exercise-detail>

        <div class="overview-exercise">
          <nb-actions size="none">
            <nb-action>
              <nb-icon
                [status]="'info'"
                class="action-icon"
                icon="layers-outline"
              ></nb-icon>
              <div class="text-hint">
                Đã làm: {{ exerciseUser.noQuiz }}/{{ exerciseUser.totalQuiz }}
              </div>
            </nb-action>

            <nb-action>
              <nb-icon
                status="success"
                class="action-icon"
                icon="checkmark-circle-outline"
              ></nb-icon>
              <span>
                {{ exerciseUser.noCorrect }}
              </span>
            </nb-action>

            <nb-action>
              <nb-icon
                status="danger"
                class="action-icon"
                icon="close-circle-outline"
              ></nb-icon>
              <span> {{ exerciseUser.noIncorrect }} </span>
            </nb-action>
          </nb-actions>
        </div>

        <button
          nbButton
          hero
          shape="round"
          size="small"
          status="success"
          [disabled]="
            loading ||
            !exercise.exQuizzes ||
            exercise.exQuizzes.length == 0 ||
            exercise.status != 1
          "
          [class.btn-pulse]="loading"
          class="action-button"
          (click)="resumeExercise()"
        >
          <nb-icon class="action-icon" icon="play-circle-outline"></nb-icon>
          Tiếp tục
        </button>
      </div>
    </div>

    <div class="contain-detail" *ngIf="view == 'finish'">
      <div class="summary">
        <div class="row">
          <div class="col-md-12 text-center">
            <i
              *ngIf="
                exerciseUser.percentage >= exerciseUser.percentCompleted &&
                exerciseUser.duration <= exerciseUser.duration
              "
              class="fas fa-trophy"
              style="font-size: 50px; color: #ffc94d"
            ></i>
            <i
              *ngIf="
                exerciseUser.percentage >= exerciseUser.percentCompleted &&
                exerciseUser.duration > exerciseUser.duration
              "
              class="fas fa-trophy"
              style="font-size: 50px; color: #00d68f"
            ></i>
            <i
              *ngIf="exerciseUser.percentage < exerciseUser.percentCompleted"
              class="fas fa-trophy"
              style="font-size: 50px"
            ></i>

            <div>
              <h4 style="margin: 10px 0; font-weight: bold; font-size: 36px">
                {{ exerciseUser.percentage }} %
              </h4>

              <div class="overview-exercise">
                <i class="fas fa-check-circle text-success"></i> Đúng:
                <span style="font-weight: bold">
                  {{ exerciseUser.noCorrect }}
                </span>

                <i class="fas fa-times-circle text-danger"></i> Sai:
                <span style="font-weight: bold">
                  {{ exerciseUser.noIncorrect }}
                </span>
              </div>
              <div class="clearfix"></div>
              <p *ngIf="exerciseUser.timeSpent > 0">
                Thời gian làm bài:
                <span *ngIf="finishedDays > 0" style="font-weight: bold">
                  {{ finishedDays }} ngày
                </span>

                <span *ngIf="finishedHours > 0" style="font-weight: bold">
                  {{ finishedHours }} giờ
                </span>

                <span *ngIf="finishedMinutes > 0" style="font-weight: bold">
                  {{ finishedMinutes }} phút
                </span>

                <span *ngIf="finishedSeconds > 0" style="font-weight: bold">
                  {{ finishedSeconds }} giây
                </span>
              </p>

              <h6
                *ngIf="exerciseUser.percentage >= exerciseUser.percentCompleted"
                style="color: #00d68f"
              >
                Bạn đã hoàn thành bài thi
              </h6>
              <h6
                *ngIf="
                  exerciseUser.percentage < exerciseUser.percentCompleted &&
                  exerciseUser.percentCompleted > 0
                "
              >
                Bạn chưa vượt yêu cầu
                {{ exerciseUser.percentCompleted }} %
              </h6>
            </div>
          </div>
        </div>

        <!-- <div
          *ngIf="exercise.messageCompleted && exercise.messageCompleted != ''"
          class="form-group"
        >
          <ngx-view-document [content]="exercise.messageCompleted"> </ngx-view-document>
        </div> -->

        <button
          nbButton
          hero
          shape="round"
          size="small"
          status="warning"
          [disabled]="loading"
          [class.btn-pulse]="loading"
          class="action-button"
          (click)="replay()"
        >
          <nb-icon
            class="action-icon"
            icon="checkmark-square-outline"
          ></nb-icon>
          Làm lại
        </button>
      </div>
    </div>

    <div
      *ngIf="
        exerciseHighest &&
        exerciseHighest.finished &&
        exerciseHighest.percentage > 0
      "
      class="contain-detail"
    >
      <nb-actions size="none">
        <nb-action>
          <nb-icon
            [status]="'info'"
            class="action-icon"
            icon="pin-outline"
          ></nb-icon>
          <div class="text-body">Kết quả tốt nhất</div>
        </nb-action>

        <nb-action>
          <nb-icon
            [status]="'info'"
            class="action-icon"
            icon="calendar-outline"
          ></nb-icon>
          <span>
            <ngx-view-time-ago
              [currentDate]="exerciseHighest.updatedOn"
            ></ngx-view-time-ago>
          </span>
        </nb-action>

        <nb-action>
          <nb-icon
            status="success"
            class="action-icon"
            icon="percent-outline"
          ></nb-icon>
          <span> {{ exerciseHighest.percentage }} </span>
        </nb-action>

        <nb-action>
          <nb-icon
            status="warning"
            class="action-icon"
            icon="clock-outline"
          ></nb-icon>
          <span> {{ exerciseHighest.timeSpent }}s </span>
        </nb-action>
      </nb-actions>
    </div>

    <ngx-exercise-history [exerciseUsers]="exerciseUsers">
    </ngx-exercise-history>
  </nb-card-body>

  <nb-card-body *ngIf="view == 'quiz'">
    <ngx-view-quiz-test
      [exerciseUser]="exerciseUser"
      (onSubmitted)="onSubmitted($event)"
      (onFinished)="onFinished($event)"
    ></ngx-view-quiz-test>
  </nb-card-body>
</nb-card>
